import defaultApi from '@/utils/request';

export default {
  // 加載列表 // S16W2001 教職員健檢補助申請作業
  S16W2001_LoadList(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S16/S16W2001_LoadList',
      params,
    });
  },
  S16W2001_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S16/S16W2001_EditViewLoad',
      params,
    });
  },
  S16W2001_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S16/S16W2001_EditViewAction',
      data,
    });
  },
  S16W2001_Delete(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S16/S16W2001_Delete',
      data,
    });
  },
  S16W2001_Send(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S16/S16W2001_Send',
      data,
    });
  },
  S16W2001_LoadPrintPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S16/S16W2001_LoadPrintPDF',
      responseType: 'blob',
      params,
    });
  },
};
